import House from '@mui/icons-material/House';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function HouseIcon(props: FixMe) {
  return <House {...props} />;
}

export default HouseIcon;
